import { fieldsType } from "@/utils/types/field";
import { operators as baseOperator } from "./base/search";
import { operators as boolOperator } from "./bool/search";
import { operators as dateOperator } from "./date/search";
import { operators as enumOperator } from "./enum/search";
import { operators as idOperator } from "./id/search";
import { operators as linkOperator } from "./link/search";
import { operators as relateOperator } from "./relate/search";
export var operatorByFieldType = function (type) {
    var fieldType = fieldsType.hasOwnProperty(type) ? type : fieldsType.base;
    switch (fieldType) {
        case fieldsType.bool:
            return boolOperator;
        case fieldsType.date:
        case fieldsType.datetime:
            return dateOperator;
        case fieldsType.enum:
            return enumOperator;
        case fieldsType.id:
            return idOperator;
        case fieldsType.link:
            return linkOperator;
        case fieldsType.relate:
            return relateOperator;
        default:
            return baseOperator;
    }
};
